import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {LocationEditComponent} from "./location-edit.component";
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputTextModule } from 'primeng/inputtext';
import {FormsModule} from "@angular/forms";
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';


@NgModule({
    declarations: [
        LocationEditComponent
    ],
    imports: [
        CommonModule,
        AutoCompleteModule,
        InputTextModule,
        FormsModule,
        ButtonModule,
        InputNumberModule,
    ]
})
export class LocationEditModule { }
